import React, { useState, useCallback } from "react";
import { Input } from "../plain-inputs";
import { Textarea } from "./textarea";

const TEXTAREAMINLENGTH = 150;

export const VariableInput = (props) => {
    const value = props.defaultValue || props.value;
    const [displayTextArea, setDisplayTextArea] = useState(value && value.length > TEXTAREAMINLENGTH);
    const [currentInput, setCurrentInput] = useState(value ? value : "");

    const handleSetText = useCallback((e) => {
        setCurrentInput(e.currentTarget.value);
        setDisplayTextArea(e.currentTarget.value && e.currentTarget.value.length > TEXTAREAMINLENGTH, []);
    });

    const output = displayTextArea ? (
        <Textarea {...props} onChange={handleSetText} valueToTransfer={currentInput} />
    ) : (
        <Input {...props} onChange={handleSetText} valueToTransfer={currentInput} />
    );

    return <span>{output}</span>;
};
